import { render, staticRenderFns } from "./importSpecificationCoding.vue?vue&type=template&id=67afd94f&scoped=true"
import script from "./importSpecificationCoding.vue?vue&type=script&lang=ts"
export * from "./importSpecificationCoding.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67afd94f",
  null
  
)

export default component.exports